import { render, staticRenderFns } from "./myActiveCoins.vue?vue&type=template&id=6f46b545&scoped=true&"
import script from "./myActiveCoins.vue?vue&type=script&lang=js&"
export * from "./myActiveCoins.vue?vue&type=script&lang=js&"
import style0 from "./myActiveCoins.vue?vue&type=style&index=0&id=6f46b545&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f46b545",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VImg,VProgressCircular})
